import {
  FETCH_ROOM_RATE_AVAILABILITY_REQUEST,
  FETCH_ROOM_RATE_AVAILABILITY_SUCCESS,
  FETCH_ROOM_RATE_AVAILABILITY_FAILURE,
} from '@store/rooms/actions';
import { RoomRateAvailability } from 'shared-types/Room';
import { mergeAndSortAvailability } from './helpers';

export type RoomStateType = {
  isAvailabilityFetching: boolean;
  availability: RoomRateAvailability;
};

export const initialState: RoomStateType = {
  isAvailabilityFetching: false,
  availability: [],
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case FETCH_ROOM_RATE_AVAILABILITY_REQUEST: {
      return {
        ...state,
        isAvailabilityFetching: true,
      };
    }
    case FETCH_ROOM_RATE_AVAILABILITY_SUCCESS: {
      if (!state.availability || !payload) {
        return {
          ...state,
          isAvailabilityFetching: false,
        };
      }

      return {
        ...state,
        isAvailabilityFetching: false,
        availability: mergeAndSortAvailability([state.availability, payload]),
      };
    }
    case FETCH_ROOM_RATE_AVAILABILITY_FAILURE: {
      return {
        ...state,
        isAvailabilityFetching: false,
        availability: null,
      };
    }
    default:
      return state;
  }
};

export default reducer;
